import React from 'react';

import {DetailPageSignoffSidebar} from 'app/components/general/DetailPageSignoffSidebar';
import {SidebarItem} from 'app/general/structures/SidebarItem';
import {getObjectSignoffURL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import type {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {DetailPageItemType} from 'app/components/general/DetailPage/types';

function SignoffLogPanelContent<ItemType extends DetailPageItemType>({
  object,
  legacyRefetch,
}: LeftSidebarPanelType<ItemType>) {
  return (
    <DetailPageSignoffSidebar
      document={object}
      refreshFunc={() => {
        legacyRefetch();
        return Promise.resolve();
      }}
    />
  );
}

function SignoffLogMenuButton<ItemType extends DetailPageItemType>({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  active,
}: LeftSidebarMenuButton<ItemType>) {
  return (
    <SidebarItem
      icon="fa fa-signature"
      title={gt('Sign Off Log')}
      active={active}
      link={getObjectSignoffURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const SignoffLogSidebar: LeftSidebarElementType<DetailPageItemType> = {
  Panel: SignoffLogPanelContent,
  MenuButton: SignoffLogMenuButton,
  type: 'left',
  sidebarName: 'showSignoff',
};
